import { runtimeEnv } from 'config/runtimeEnv';
import { API_ENDPOINT } from './Api';
import { setCurrentUser } from 'utils/utils';
import requestInstance from './Request';

let env = runtimeEnv('B2B_API_BASE_URL');

//BillingList Service
export const billingListService = async (payload) => {
  const payloadData = {
    page: payload?.page === 0 || payload?.page ? parseInt(payload?.page) + 1 : 1,
    pageSize: payload?.pageSize || 10,
    status: payload?.status || '',
    location: payload?.city || '',
    company: payload.company || '',
    companyId: payload.companyId || '',
    fromDate: payload.fromDate || '',
    toDate: payload.toDate || '',
  };

  const res = await requestInstance
    .get(
      `${env}${API_ENDPOINT.operations.billing.billingListApi}?page=${payloadData?.page}&pageSize=${payloadData?.pageSize}&status=${payloadData?.status}&location=${payloadData?.location}&companyId=${payloadData?.companyId}&dateFrom=${payloadData?.fromDate}&dateTo=${payloadData?.toDate}`,
    )
    .catch((err) => err.response);
  return setCurrentUser(res);
};

// Billing Get Invoice Details
export const billingInvoiceDetailsService = async (payload) => {
  let url;
  if (payload?.type === 'public') {
    url = `${env}${API_ENDPOINT.operations.billing.bookinginvoiceDetails}?magicToken=${payload?.id}`;
  } else {
    url = `${env}${API_ENDPOINT.operations.billing.bookinginvoiceDetails}?tripId=${payload?.id}`;
  }

  const res = await requestInstance.get(url).catch((err) => err.response);
  return setCurrentUser(res);
};

// Billing Get Price Details
export const billingPriceDetailsService = async (id) => {
  const res = await requestInstance
    .get(`${env}${API_ENDPOINT.operations.billing.billingPriceDetails}?tripId=${id}`)
    .catch((err) => err.response);
  return setCurrentUser(res);
};

//Billing Extra charges calculation API
export const billingExtraChargeCalcService = async (payload) => {
  const res = await requestInstance
    .get(
      `${env}${API_ENDPOINT.operations.billing.bookingChargesCalculationApi}?tripId=${payload?.tripId}&extraTime=${payload?.extraTime}&extraDistance=${payload?.extraDistance}`,
    )
    .catch((err) => err.response);
  return setCurrentUser(res);
};

// add Billing Price Details
export const addBillingPriceDetailsService = async (payload) => {
  const res = await requestInstance
    .patch(
      `${env}${API_ENDPOINT.operations.billing.billingPriceDetails}/${payload?.id}`,
      payload.obj,
    )
    .catch((err) => err.response);
  return setCurrentUser(res);
};

// Billing Request Approval Service
export const billingRequestApprovalService = async (payload) => {
  const res = await requestInstance
    .post(`${env}${API_ENDPOINT.operations.billing.billingRequestForApproval}`, payload)
    .catch((err) => err.response);
  return setCurrentUser(res);
};

// Billing Request Consolidated Invoice Service
export const billingConsolidatedInvoiceService = async (payload) => {
  const res = await requestInstance
    .post(`${env}${API_ENDPOINT.operations.billing.billingConsolidatedInvoiceApi}`, payload)
    .catch((err) => err.response);
  return setCurrentUser(res);
};

// Billing Generate Consolidated Invoice Service
export const getbillingConsolidatedInvoiceService = async (payload) => {
  let url;
  if (payload?.type === 'public') {
    url = `${env}${API_ENDPOINT.operations.billing.consolidateInvoiceDetailApi}/?magicToken=${payload?.id}`;
  } else {
    url = `${env}${API_ENDPOINT.operations.billing.billingConsolidatedInvoiceApi}/${payload?.id}`;
  }
  const res = await requestInstance.get(url).catch((err) => err.response);
  return setCurrentUser(res);
};

//Billing Generate Invoice
export const billingGenerateInvoiceService = async (payload) => {
  const res = await requestInstance
    .post(
      `${env}${API_ENDPOINT.operations.billing.billingListApi}/${payload?.tripId}?type=${payload?.generateType}`,
    )
    .catch((err) => err.response);
  return setCurrentUser(res);
};

export const consolidateInvoiceMatrixService = async (payload) => {
  let url;
  if (payload?.type === 'public') {
    url = `${env}${API_ENDPOINT.operations.billing.consolidateInvoiceMatrixApi}/?magicToken=${payload?.id}`;
  } else {
    url = `${env}${API_ENDPOINT.operations.billing.consolidateInvoiceMatrixApi}/${payload?.id}`;
  }
  const res = await requestInstance.get(url).catch((err) => err.response);
  return setCurrentUser(res);
};

export const finalInvoiceService = async (payload) => {
  let url = payload?.billingType === 'billToCreditCard' ? '&billingType=1' : '';
  const page = payload?.page === 0 || payload?.page ? parseInt(payload?.page) + 1 : 1;
  const res = await requestInstance
    .get(
      `${env}${API_ENDPOINT.operations.billing.finalInvoiceApi}?page=${page}&pageSize=${payload?.pageSize || 10}&companyId=${payload?.companyId}&location=${payload?.city}&dateFrom=${payload?.fromDate}&dateTo=${payload?.toDate}${url}`,
    )
    .catch((err) => err.response);
  return setCurrentUser(res);
};

// Billing Request Approval Link
export const billingRequestApprovalLinkService = async (payload) => {
  const res = await requestInstance
    .post(`${env}${API_ENDPOINT.operations.billing.billingRequestForApprovalLink}`, payload)
    .catch((err) => err.response);
  return setCurrentUser(res);
};
// Billing Generate Payment Link Service
// 1. Generate Consolidated Payment Link
export const generateConsolidatedPaymentLinkApi = async (consolidatedInvoiceId) => {
  const res = await requestInstance
    .post(`${env}${API_ENDPOINT.payment.generateConsolidatedPaymentLink(consolidatedInvoiceId)}`)
    .catch((err) => err.response);
  return setCurrentUser(res);
};

// 2. Read/Get Consolidated Payment Link
export const getConsolidatedPaymentLinkApi = async (consolidatedInvoiceId) => {
  const res = await requestInstance
    .get(`${env}${API_ENDPOINT.payment.getConsolidatedPaymentLink(consolidatedInvoiceId)}`)
    .catch((err) => err.response);
  return setCurrentUser(res);
};

// 3. Check Consolidated Payment Status
export const getConsolidatedPaymentStatusApi = async (consolidatedInvoiceId) => {
  const res = await requestInstance
    .get(`${env}${API_ENDPOINT.payment.getConsolidatedPaymentStatus(consolidatedInvoiceId)}`)
    .catch((err) => err.response);
  return setCurrentUser(res);
};

// 4. Cancel Consolidated Payment Link
export const cancelConsolidatedPaymentLinkApi = async (consolidatedInvoiceId) => {
  const res = await requestInstance
    .post(`${env}${API_ENDPOINT.payment.cancelConsolidatedPaymentLink(consolidatedInvoiceId)}`)
    .catch((err) => err.response);
  return setCurrentUser(res);
};

// Update Invoice GST / Taxes
export const updateInvoiceTaxesService = async (tripId, payload) => {
  const res = await requestInstance
    .patch(
      `${env}${API_ENDPOINT.operations.billing.bookinginvoiceDetails}/${tripId}/taxes`,
      payload,
    )
    .catch((err) => err.response);
  return setCurrentUser(res);
};

// 5. Send Consolidated Invoice Email
export const sendConsolidatedInvoiceEmailService = async (invoiceId, recipients) => {
  const res = await requestInstance
    .post(
      `${env}${API_ENDPOINT.operations.billing.sendConsolidatedInvoiceEmail(invoiceId)}`,
      recipients?.length ? { recipients } : {},
    )
    .catch((err) => err.response);
  return setCurrentUser(res);
};

// Get Billing Employees
export const getBillingEmployeesService = async (
  companyId,
  page = 1,
  pageSize = 10,
  status = 'Approved',
) => {
  const res = await requestInstance
    .get(
      `${env}${API_ENDPOINT.operations.billing.billingEmployeesApi1}?companyId=${companyId}&page=${page}&pageSize=${pageSize}`,
    )
    .catch((err) => err.response);
  return setCurrentUser(res);
};

// Get Eligible Bill-Self Invoices
export const getBillSelfEligibleInvoicesService = async (
  companyId,
  cityId,
  employeeId,
  page = 1,
  pageSize = 10,
  dateFrom,
  dateTo,
) => {
  let url =
    `${env}${API_ENDPOINT.operations.billing.billSelfEligibleInvoicesApi}` +
    `?companyId=${companyId}` +
    `&cityId=${cityId}` +
    `&employeeId=${employeeId}` +
    `&page=${page}` +
    `&pageSize=${pageSize}`;

  if (dateFrom) url += `&dateFrom=${dateFrom}`;
  if (dateTo) url += `&dateTo=${dateTo}`;

  const res = await requestInstance.get(url).catch((err) => err.response);
  return setCurrentUser(res);
};

// Generate Bill-Self Consolidated Invoice
export const generateBillSelfConsolidatedInvoiceService = async (payload) => {
  const res = await requestInstance
    .post(`${env}${API_ENDPOINT.operations.billing.billSelfConsolidatedInvoiceApi}`, payload)
    .catch((err) => err.response);
  return setCurrentUser(res);
};

// Get Bill-Self Consolidated Invoices List
export const getBillSelfConsolidatedInvoicesListService = async (payload) => {
  const {
    companyId,
    cityId,
    employeeId,
    page = 1,
    pageSize = 10,
    dateFrom,
    dateTo,
  } = payload || {};
  let url = `${env}${API_ENDPOINT.operations.billing.billSelfConsolidatedInvoiceApi}?companyId=${companyId}&cityId=${cityId}&employeeId=${employeeId}&page=${page}&pageSize=${pageSize}`;
  if (dateFrom) url += `&dateFrom=${dateFrom}`;
  if (dateTo) url += `&dateTo=${dateTo}`;
  const res = await requestInstance.get(url).catch((err) => err.response);
  return setCurrentUser(res);
};

// Get Bill-Self Consolidated Invoice Details
export const getBillSelfConsolidatedInvoiceDetailsService = async (id) => {
  const res = await requestInstance
    .get(`${env}${API_ENDPOINT.operations.billing.billSelfConsolidatedInvoiceApi}/${id}`)
    .catch((err) => err.response);
  return setCurrentUser(res);
};
